import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/alin-botoksu-nedir/page.tsx");
